export default __webpack_public_path__ + "static/SRUS RTL120 - Product Specifications & Technical Data-c84c5418e59d7c7b9b1756bf2d11408c.pdf";